import { styled } from '@xstyled/styled-components';

export const ModalWrapper = styled.div`
  position: relative;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  padding: 20px 40px;
  max-height: 100vh;
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  width: 33px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.7;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-family: ralewayBold;
  font-size: 16px;
  font-weight: 700;
  text-align: left;
  line-height: 150%;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-family: Raleway;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  @media (max-height: 900px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
  @media (max-height: 780px) {
    font-size: 12.5px;
    margin-bottom: 4px;
  }
`;

/** What a field is for, under it; the field names it as its description. */
export const FieldHelp = styled.p`
  margin: 6px 0 0;
  font-family: Raleway;
  font-size: 12px;
  line-height: 16px;
  color: #767676;
`;

export const OptionalTag = styled.span`
  margin-left: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #767676;
`;

export const Form = styled.form`
  display: contents;
`;

/** Every control of the panel, locked together while a save is on its way. */
export const Fields = styled.fieldset`
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
`;

export const ButtonRow = styled.div`
  display: flex;
  margin-top: 12px;
  margin-bottom: 20px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 10px 20px;
  border-radius: 10px;
  font-family: Raleway;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: #9738ff;
  color: white;
  letter-spacing: 0.3px;
  transition: background 0.15s ease;
  &:hover {
    background: #7a2dcc;
  }
  &:active {
    background: #5d22a3;
  }
  @media (max-height: 900px) {
    padding: 9px 18px;
    font-size: 14.5px;
  }
  @media (max-height: 780px) {
    padding: 8px 16px;
    font-size: 14px;
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: 20px;
  @media (max-height: 900px) {
    margin-bottom: 14px;
  }
  @media (max-height: 780px) {
    margin-bottom: 12px;
  }
`;
